module.exports = __webpack_public_path__ + "img/person-major.8554b520.svg";